import { Divider, Stack } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import { CentredBox } from 'src/components/CentredBox';
import { Footer } from 'src/components/Footer';
import { Header } from 'src/components/Header';

import * as styles from './styles.css';

type Props = Pick<ComponentProps<typeof Stack>, 'children'>;

export const PromptLayout = ({ children }: Props) => (
  <CentredBox background="surface" boxShadow="small" className={styles.fadeIn}>
    <Stack space="xlarge">
      <Header />

      {children}

      <Divider />

      <Footer />
    </Stack>
  </CentredBox>
);
